// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Segment, Button } from 'semantic-ui-react';
// local
// views
import Notification from 'app/ui/commons/notification/Notification';
// actions
import { closeSaveUpdate, ACTION } from 'app/redux/actions/modal';

class SaveUpdateModal extends Component {
    componentWillUnmount = () => this.onClose();

    onClose = () => this.props.options.dispatch(closeSaveUpdate());

    onSubmit = () => {
        const { onConfirmModal, action } = this.props.options;
        if (onConfirmModal && onConfirmModal(action)) {
            this.onClose();
        }
    };

    render() {
        const { id, children, options } = this.props;
        const { isOpened, action, title, loading, error } = options;
        return (
            <Modal centered={true} id={id}   size="small" open={isOpened} onClose={this.onClose}  style={{ position: 'absolute', top: '10%' }}>
                <Modal.Header>
                    {action === ACTION.ADD ? 'Adicionar' : 'Atualizar'} - {title}
                </Modal.Header>
                <Segment vertical loading={loading}>
                    {error ? <Notification message={error.errors} isError /> : null}
                    <Modal.Content>{children}</Modal.Content>
                    <Modal.Actions>
                        <Button content="Cancelar" onClick={this.onClose} />
                        <Button className="highlight" content="Salvar" onClick={this.onSubmit} />
                    </Modal.Actions>
                </Segment>
            </Modal>
        );
    }
}

SaveUpdateModal.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.object.isRequired,
    options: PropTypes.object,
};

export default SaveUpdateModal;
